(function () {
  function isLocationFilterActive() {
    var filters = document.querySelector('[data-page-events-filters]');
    if (!filters) return true;
    return filters.querySelectorAll('[data-events-filter-location][aria-pressed="true"]').length > 0;
  }

  function setLoadMoreVisible(wrapper, visible) {
    if (!wrapper) return;
    wrapper.hidden = !visible;
    wrapper.classList.toggle('is-visible', visible);
  }

  function updateShowMoreButton(listings) {
    var wrapper = listings.querySelector('[data-page-events-load-more]');
    if (!wrapper) return;

    var list = listings.querySelector('[data-events-list]');
    if (!list) return;

    if (!isLocationFilterActive()) {
      setLoadMoreVisible(wrapper, false);
      return;
    }

    var remaining = list.querySelectorAll('[data-events-card].event-card--page-hidden');
    setLoadMoreVisible(wrapper, remaining.length > 0);
  }

  function showMore(listings) {
    var list = listings.querySelector('[data-events-list]');
    var button = listings.querySelector('[data-page-events-show-more]');
    if (!list || !button) return;

    var pageSize = Number(button.dataset.pageSize || 8);
    if (pageSize < 1) pageSize = 8;

    var hiddenCards = list.querySelectorAll('[data-events-card].event-card--page-hidden');
    var revealed = 0;

    hiddenCards.forEach(function (card) {
      if (revealed >= pageSize) return;
      card.classList.remove('event-card--page-hidden');
      revealed += 1;
    });

    updateShowMoreButton(listings);

    if (typeof window.applyPageEventsFilters === 'function') {
      window.applyPageEventsFilters();
    }
  }

  function bindShowMore(listings) {
    if (listings.dataset.pageEventsShowMoreBound === 'true') return;
    listings.dataset.pageEventsShowMoreBound = 'true';

    var button = listings.querySelector('[data-page-events-show-more]');
    if (!button) return;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      showMore(listings);
    });

    if (typeof window.applyPageEventsFilters === 'function') {
      window.applyPageEventsFilters();
    } else {
      updateShowMoreButton(listings);
    }
  }

  function init() {
    document.querySelectorAll('[data-page-events-listings]').forEach(bindShowMore);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.updatePageEventsShowMore = updateShowMoreButton;
})();
